import React from "react";
import { policyNameId } from "../../utils/utils";

const PremiumCalculatorDataPreview = ({
  calculation,
  data_loop,
  total_20,
  total_40,
  final_premium_amount,
  totalFac,
  totalSurvivalBenefit,
}) => {
  const policyName = policyNameId[calculation?.payload?.policy] || "Unknown Policy";
  const trSa = calculation?.payload?.trSa ?? calculation?.payload?.term_rider;
  const hasTrSa =
    trSa &&
    trSa !== "0" &&
    trSa !== 0 &&
    !isNaN(parseInt(trSa)) &&
    parseInt(trSa) > 0;

  console.log("calculation & data_loop 3333333", calculation, data_loop);
  return (
    <div>
      {" "}
      {/* this for LIC Jibon Swapno */}
      {policyName === "LIC Jibon Swapno" && (
        <div className="cumalative_data mt-4">
          <table className="table">
            <tr>
              <td>Year</td>
              <td>Premium Payable</td>
              <td>Cumulative paid premium</td>
              <td>Payable on Death before Maturity date</td>
              <td>Critical Illness Benefit</td>
              <td>Maturity Benefit</td>

              <td>Maturity payable if BDT 20 Bonus is declared</td>
              <td>Maturity payable if BDT 40 Bonus is declared</td>
            </tr>

            {data_loop.length &&
              data_loop.map((row, key) => {
                return (
                  <tr id={key}>
                    <td>{key + 1}</td>
                    <td>{parseInt(calculation?.instPrem)}</td>
                    <td>{row}</td>
                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation?.payload?.sum_assured} + Bonus
                        {hasTrSa ? ` + ${trSa}` : ""}
                      </td>
                    )}
                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation.critical_illness_amount}
                      </td>
                    )}
                    {key == 0 && <td rowSpan={data_loop.length}></td>}
                    <td>{parseInt(calculation?.payload?.sum_assured) * 0.02}</td>
                    <td>{parseInt(calculation?.payload?.sum_assured) * 0.04}</td>
                  </tr>
                );
              })}
            <tr>
              <td colSpan={5}>
                On maturity date at the end of {parseInt(calculation?.payload?.term)} year
              </td>

              <td>{calculation?.payload?.sum_assured}+Bonus</td>

              <td>{parseInt(calculation?.payload?.sum_assured) + parseInt(total_20)}</td>
              <td>{parseInt(calculation?.payload?.sum_assured) + parseInt(total_40)}</td>
            </tr>
          </table>
        </div>
      )}
      {/* this for LIC Jibon Swapno */}
      {policyName === "LIC Jibon Swapno-SinglePremium" && (
        <div className="cumalative_data mt-4">
          <table className="table">
            <tr>
              <td>Year</td>
              <td>Age</td>
              <td>Single Premium</td>
              <td>Payable on Death before Maturity date</td>
              <td>Maturity Benefit</td>

              <td>Maturity payable if BDT 20 Bonus is declared</td>
              <td>Maturity payable if BDT 40 Bonus is declared</td>
            </tr>

            {data_loop.length &&
              data_loop?.map((row, key) => {
                return (
                  <tr id={key}>
                    <td>{key + 1}</td>
                    <td>{calculation.age + key}</td>
                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {parseInt(calculation?.instPrem)}
                      </td>
                    )}

                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation?.payload?.sum_assured}+Bonus
                      </td>
                    )}
                    {key == 0 && <td rowSpan={data_loop.length}></td>}

                    <td>{parseInt(calculation?.payload?.sum_assured) * 0.02}</td>
                    <td>{parseInt(calculation?.payload?.sum_assured) * 0.04}</td>
                  </tr>
                );
              })}
            <tr>
              <td colSpan={4}>
                On maturity date at the end of {parseInt(calculation?.payload?.term)} year
              </td>

              <td>{calculation?.payload?.sum_assured}+Bonus</td>

              <td>{parseInt(calculation?.payload?.sum_assured) + parseInt(total_20)}</td>
              <td>{parseInt(calculation?.payload?.sum_assured) + parseInt(total_40)}</td>
            </tr>
          </table>
        </div>
      )}
      {policyName === "LIC Jibon Bijoy" && (
        <div className="cumalative_data mt-4">
          <table className="table">
            <tr>
              <td>Year</td>
              <td>Yearly Premium</td>
              <td>Total paid premium at year end</td>
              <td>Survival Benefit</td>
              <td>Payable On Death Maturity Date</td>
              <td>Critical Illness Benefit</td>
              <td>Maturity Benefit</td>
              <td>Maturity payable if BDT 50 Bonus is declared</td>
              <td>FAC</td>
            </tr>

            {data_loop.length &&
              data_loop.map((row, key) => {
                return (
                  <tr id={key}>
                    <td>{key + 1}</td>
                    <td>{final_premium_amount}</td>
                    <td>{final_premium_amount * (key + 1)}</td>

                    {parseInt(parseInt(calculation?.payload?.term)) === 6 ? (
                      key + 1 === 2 || key + 1 === 4 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {parseInt(calculation?.payload?.sum_assured) * 0.25}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {/* Content for the outer else condition */}
                        </td>
                      )
                    ) : parseInt(parseInt(calculation?.payload?.term)) === 9 ? (
                      key + 1 === 3 || key + 1 === 6 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {parseInt(calculation?.payload?.sum_assured) * 0.25}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {/* Content for the outer else condition */}
                        </td>
                      )
                    ) : parseInt(parseInt(calculation?.payload?.term)) === 12 ? (
                      key + 1 === 4 || key + 1 === 8 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {parseInt(calculation?.payload?.sum_assured) * 0.25}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {/* Content for the outer else condition */}
                        </td>
                      )
                    ) : (
                      <td style={{ verticalAlign: "middle" }}>
                        {/* Content for the outer else condition */}
                      </td>
                    )}

                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation?.payload?.sum_assured} + Bonus
                        {hasTrSa ? ` + ${trSa}` : ""}
                      </td>
                    )}

                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation.critical_illness_amount}
                      </td>
                    )}

                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      ></td>
                    )}

                    <td>{parseInt(calculation?.payload?.sum_assured) * 0.05}</td>
                    {parseInt(parseInt(calculation?.payload?.term)) === 6 ? (
                      key === 0 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.12).toFixed(2)}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.05).toFixed(2)}
                        </td>
                      )
                    ) : parseInt(parseInt(calculation?.payload?.term)) === 9 ? (
                      key === 0 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.18).toFixed(2)}
                        </td>
                      ) : key === 1 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.1).toFixed(2)}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.05).toFixed(2)}
                        </td>
                      )
                    ) : parseInt(parseInt(calculation?.payload?.term)) === 12 ? (
                      key === 0 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.25).toFixed(2)}
                        </td>
                      ) : key === 1 ? (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.1).toFixed(2)}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {(final_premium_amount * 0.05).toFixed(2)}
                        </td>
                      )
                    ) : (
                      <td style={{ verticalAlign: "middle" }}>
                        {/* Content for the outer else condition */}
                      </td>
                    )}
                  </tr>
                );
              })}
            <tr>
              <td colSpan={6}>
                On maturity date at the end of {parseInt(calculation?.payload?.term)} year
              </td>
              <td>
                {parseInt(calculation?.payload?.sum_assured) -
                  parseInt(calculation?.payload?.sum_assured) * 0.25 * 2}{" "}
                + Bonus
              </td>
              <td>
                {" "}
                {parseInt(calculation?.payload?.sum_assured) * 0.25 * 2} +{" "}
                {parseInt(calculation?.payload?.sum_assured) * 0.05 * parseInt(calculation?.payload?.term)} ={" "}
                {parseInt(calculation?.payload?.sum_assured) * 0.25 * 2 +
                  parseInt(calculation?.payload?.sum_assured) * 0.05 * parseInt(calculation?.payload?.term)}
              </td>
              <td>{totalFac.toFixed(2)}</td>
            </tr>
          </table>
        </div>
      )}
      {policyName === "LIC Jibon Bijoy-SinglePremium" && (
        <div className="cumalative_data mt-4">
          <table className="table">
            <tr>
              <td>Year</td>
              <td>Age</td>
              <td>Single Premium</td>
              <td>Survival Benefit</td>
              <td>Payable on Death Maturity date</td>
              <td>Maturity Benefit</td>
              <td>Maturity payable if BDT 40 Bonus is declared</td>
              <td>FAC</td>
            </tr>

            {data_loop.length &&
              data_loop.map((row, key) => {
                return (
                  <tr id={key}>
                    <td>{key + 1}</td>
                    <td>{calculation.age + key}</td>
                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {parseInt(calculation?.instPrem)}
                      </td>
                    )}

                    {key + 1 != parseInt(calculation?.payload?.term) ? (
                      <td style={{ verticalAlign: "middle" }}>
                        {parseInt(calculation?.payload?.sum_assured) * 0.1}
                      </td>
                    ) : (
                      <td style={{ verticalAlign: "middle" }}>
                        {/* Content for the else condition */}
                      </td>
                    )}

                    {key == 0 && (
                      <td
                        rowSpan={data_loop.length}
                        style={{ verticalAlign: "middle" }}
                      >
                        {calculation?.payload?.sum_assured}+Bonus
                      </td>
                    )}
                    {key == 0 && <td rowSpan={data_loop.length}></td>}
                    <td style={{ verticalAlign: "middle" }}>
                      {(parseInt(calculation?.payload?.sum_assured) * 0.04).toFixed(2)}
                    </td>
                    {key == 0 ? (
                      <td style={{ verticalAlign: "middle" }}>
                        {(parseInt(calculation?.instPrem) * 0.03).toFixed(2)}
                      </td>
                    ) : (
                      <td style={{ verticalAlign: "middle" }}></td>
                    )}
                  </tr>
                );
              })}
            <tr>
              <td colSpan={4}>
                On maturity date at the end of {parseInt(calculation?.payload?.term)} year
              </td>
              <td>{calculation?.payload?.sum_assured}+Bonus</td>
              <td>
                {parseInt(calculation?.payload?.sum_assured) -
                  parseInt(totalSurvivalBenefit)}{" "}
                + Bonus
              </td>
              <td>
                {parseInt(calculation?.payload?.sum_assured) -
                  parseInt(totalSurvivalBenefit)}{" "}
                + {parseInt(total_40)} ={" "}
                {parseInt(calculation?.payload?.sum_assured) -
                  parseInt(totalSurvivalBenefit) +
                  parseInt(total_40)}
              </td>
              <td>{(parseInt(calculation?.instPrem) * 0.03).toFixed(2)}</td>
            </tr>
          </table>
        </div>
      )}
    </div>
  );
};
export default PremiumCalculatorDataPreview;
